<template>
<div class="chapter">
<div class="inner_page">
<a id="page_1"></a>
<p class="titlea">Casemate Short History</p>
<h1 class="title">SPECIAL OPERATIONS IN WORLD WAR II</h1>
<div class="img_container">
<img alt="images" src="images/linec.jpg"/>
</div>
<p class="sub-title">THE SOE AND OSS</p>
<p class="author">James Stejskal</p>
<div class="img_container">
<img alt="images" src="images/pub.jpg"/>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 01_Title.vue?760c0d3a